import React, { useState } from 'react';
import Inputs from 'components/inputs/inputs';
import Clock from './clock';
import moment from 'moment';
import { Table } from 'react-bootstrap';

const styles = {
  button: {
    padding: '1.5rem 3rem',
    display: 'inline-block',
    margin: '1rem'
  },
  buttonsHolder: {
    display: 'flex',
    textAlign: 'center',
    flexDirection: 'column'
  },
  timeHeader: {
    width: '4rem',
    display: 'inline-block'
  },
  actionHeader: {
    width: '100%'
  }
};

const timeSateDefault = 'default';
const timeStateStarted = 'started';
const timeStateBreak = 'break';

export default function TimeAndAttendance(props) {
  const [timeState, setTimeState] = useState(timeSateDefault);
  const [historyItems, setHistoryItems] = useState([]);

  const onPunchIn = () => {
    setTimeState(timeStateStarted);
    setHistoryItems([...historyItems, { time: new Date(), type: 'punchIn', label: 'Punch In' }]);
  };

  const onPunchOut = () => {
    setTimeState(timeSateDefault);
    setHistoryItems([...historyItems, { time: new Date(), type: 'punchOut', label: 'Punch Out' }]);
  };

  const onStartBreak = () => {
    setTimeState(timeStateBreak);
    setHistoryItems([...historyItems, { time: new Date(), type: 'startBreak', label: 'Start Break' }]);
  };
  const onEndBreak = () => {
    setTimeState(timeStateStarted);
    setHistoryItems([...historyItems, { time: new Date(), type: 'endBreak', label: 'End Break' }]);
  };

  const renderButtons = () => {
    if (timeState === timeSateDefault) {
      return (
        <div style={styles.buttonsHolder}>
          <Inputs.Button variant='app' style={styles.button} onClick={onPunchIn} iconClass='icons8-dashboard' label='Punch In' />
        </div>
      );
    }
    if (timeState === timeStateStarted) {
      return (
        <div style={styles.buttonsHolder}>
          <Inputs.Button variant='app' style={styles.button} onClick={onStartBreak} iconClass='icons8-dashboard' label='Start Break' />
          <Inputs.Button variant='app' style={styles.button} onClick={onPunchOut} iconClass='icons8-dashboard' label='Punch Out' />
        </div>
      );
    }

    if (timeState === timeStateBreak) {
      return (
        <div style={styles.buttonsHolder}>
          <Inputs.Button variant='app' style={styles.button} onClick={onEndBreak} iconClass='icons8-dashboard' label='End Break' />
          <Inputs.Button variant='app' style={styles.button} onClick={onPunchOut} iconClass='icons8-dashboard' label='Punch Out' />
        </div>
      );
    }
    return null;
  };

  const renderHistoryRow = (item, index) => {
    return (
      <tr key={index}>
        <td>{moment(item.time).format('LT')}</td>
        <td>{item.label}</td>
      </tr>
    );
  };

  const renderHistory = () => {
    if (historyItems.length === 0) return null;

    return (
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>
              <span style={styles.timeHeader}>Time</span>
            </th>
            <th style={styles.actionHeader}>Action</th>
          </tr>
        </thead>
        <tbody>{historyItems.map((item, index) => renderHistoryRow(item, index))}</tbody>
      </Table>
    );
  };

  return (
    <div>
      <Clock />
      {renderButtons()}
      {renderHistory()}
    </div>
  );
}
